const env = {
    API_URL: "https://62emqlgum8.execute-api.us-east-1.amazonaws.com/prod/",
    AUD: "https://api.moltenhosting.com",
    CLIENT_ID:"w9EajCeKzyY9LSzRIwgWPtZ09woLXssT",
    DOMAIN:"moltenhosting.us.auth0.com",
    SUBSCRIPTION_REQUIRED: true,
    STRIPE_KEY: "pk_live_51HfrrjBYwQOj4dpU5Jo8BBBWrWyGu9i93PKVs1IoTdbTEpw3bWegYb3Xh2qZRmxdVfCGHm6hpAicVOeTXJa8tlMc00FHGfTSwc"
};
export default env;
